import kuikPos from '../../services/api/kuikPos';
import { Pos } from '../../services/api/kuikPos/types';

const createTerminalPos = async (terminal: Pos) => {
  return await kuikPos.createTerminal(terminal);
};

const fetchTerminals = async () => {
  console.log('fetchTerminals function called');
  return await kuikPos.getTerminals();
};

const createPaymentGateway = async (data: any) => {
  console.log('createPaymentGateway function called with data:', data);
  return await kuikPos.createPaymentGateway(data);
};

const getPaymentSettings = async () => {
  console.log('getPaymentSettings function called');
  return await kuikPos.getPaymentSettings();
};

export default {
  createTerminalPos,
  fetchTerminals,
  createPaymentGateway,
  getPaymentSettings,
};
